var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","grid-list-lg":""}},[_c('v-flex',{attrs:{"xs12":""}},[(!_vm.urlInput)?_c('file-input',{attrs:{"conversionType":_vm.conversionType}}):_vm._e(),_vm._v(" "),(_vm.urlInput)?_c('url-input',{attrs:{"conversionType":_vm.conversionType}}):_vm._e()],1),_vm._v(" "),_c('conversion-results')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330ead13","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeoConverter.vue
// module id = 272
// module chunks = 1